import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { RegisterCandidateType } from '../Actions'
import { REGISTER_CANDIDATE_ACTION } from '../constants/action-types'

const initialState = {
  isLoading: false,
  errorMessage: '',
}

const reducer = persistReducer(
  { storage, key: 'candidate-register', whitelist: [] },
  (state: RegisterCandidateType = initialState, action: ActionTypes) => {
    switch (action.type) {
      // For add employee
      case REGISTER_CANDIDATE_ACTION.REGISTER_CANDIDATE_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          isLoading: true,
        }

      case REGISTER_CANDIDATE_ACTION.REGISTER_CANDIDATE_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      case REGISTER_CANDIDATE_ACTION.REGISTER_CANDIDATE_FAILED:
        return {
          ...state,
          errorMessage: '',
          isLoading: false,
        }

      default:
        return state
    }
  }
)

export default reducer
